import { render, staticRenderFns } from "./SmartTrade.vue?vue&type=template&id=380a9be2&scoped=true"
import script from "./SmartTrade.vue?vue&type=script&lang=js"
export * from "./SmartTrade.vue?vue&type=script&lang=js"
import style0 from "./SmartTrade.vue?vue&type=style&index=0&id=380a9be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a9be2",
  null
  
)

export default component.exports